import { render } from "./richiediPagamentoModal.vue?vue&type=template&id=d205e326&scoped=true&ts=true"
import script from "./richiediPagamentoModal.vue?vue&type=script&lang=ts"
export * from "./richiediPagamentoModal.vue?vue&type=script&lang=ts"

import "./richiediPagamentoModal.vue?vue&type=style&index=0&id=d205e326&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d205e326"]])

export default __exports__